<template>
    <div>
    </div>
</template>
<script>
import RiskhubLogo from '@/components/Logo/RiskhubLogo';

export default {
  components: {
    RiskhubLogo,
  },
  computed: {
    authLoading() {
      return this.$auth.loading;
    },
  },
  watch: {
    authLoading: {
      handler(newAuthLoading) {
        if (!newAuthLoading) {
          this.redirect();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async redirect() {
      if (this.$auth.isAuthenticated) {
        try {
          // User object isnt there, fetch it!
          if (!this.$auth.authCheck) {
            console.log('Fetching user..');
            await this.$store.dispatch('fetchUser');
          }
          console.log('Redirecting user to dashboard..');
          // Now redirect
          await this.$router.push({ name: 'dashboard' });
          return;
        } catch (err) {
          throw new Error(`Problem handling: ${err}.`);
        }
      }
      this.login();
    },
    login() {
      console.log('Redirecting to login provider..');
      this.$auth.loginWithRedirect();
    },
  },
};
</script>
<style lang="scss">
    .home-header {
        height: 7em;
    }
    .homepage-image-mobile {
        display: none;
    }
    .login-btn {
        color: #4D738A;
        margin-right: 70px;
        font-weight: bold;
    }
    .homepage-text-container {
        padding-top: 3vh;
        padding-bottom: 3em;
        h1 {
            font-size: 3.1rem;
        }
        .homepage-text {
            color: #86939E;
            margin-top: 30px;
            font-size: 14px;
        }
    }
    img.homepage-scene {
        width: 100%;
    }
    @media screen and (max-width: 1024px) {
        .login-btn {
            margin-right: 0;
        }
        img.homepage-scene {
            width: 167%;
        }
        .homepage-text-container {
            h1 {
                font-size: 2.5rem;
            }
        }
    }
    @media screen and (max-width: 1023px) {
        .homepage-image-mobile {
            display: block;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .homepage-image {
            display: none;
        }
        .homepage-text-container {
            max-width: 100%;
            flex: 0 0 100%;
            background: #fff;
        }
        img.homepage-scene {
            height: 83%;
        }
    }
    @media screen and (max-width: 375px) {
        .home-wrapper {
            .homepage-text-container {
                h1 {
                    font-size: 2.0rem;
                }
            }
        }
    }
</style>
